import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';
import { CloseRouteDialogMessage, MessageBusService, PublicProfileMessage } from 'src/app/core/services/message-bus.service';
import { PublicProfileService } from 'src/app/core/services/public-profile.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { PublicProfile } from 'src/app/shared/models/people/public-profile.model';

@Component({
  selector: 'app-reschedule-public-profile',
  templateUrl: './reschedule-public-profile.component.html',
  styleUrls: ['./../../styles/public-profile.css', './reschedule-public-profile.component.css'],
  encapsulation: ViewEncapsulation.None  
})
export class ReschedulePublicProfileComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();
  nickname: string;
  accountName: string;
  language: string;
  publicProfile: PublicProfile;
  specialties: string;  
  initials: any;

  constructor(
    private route : ActivatedRoute,
    private router: Router,    
    private baseService: BaseService,
    private messageBusService: MessageBusService,
    private publicProfileService: PublicProfileService,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private utilsService: UtilsService
  ) { }
  
  ngOnInit(): void {
    this.language = this.locale.language;
    this.nickname = this.route.snapshot.params.nickname;
    this.accountName = this.baseService.getCliniwebDirectoryCompanyName();

    this.getPublicProfile()
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(publicProfile => {
        this.publicProfile = publicProfile;

        // Check if the profile is deleted or not approved
        if (this.publicProfile == null 
          || this.publicProfile.eliminado.toLocaleLowerCase() == "s" 
          || this.publicProfile.aprobado.toLocaleLowerCase() == "n") {
            this.router.navigate(["/not-found"]);
            return;
        }        

        this.specialties = this.getSpecialties();        
        this.initials = this.utilsService.getPersonInitials(this.publicProfile.idPerfilPublico, this.publicProfile.nombrePersona);

        this.sendPublicProfile();
      }
    );

    // On Header Back click
    this.messageBusService.onNavigateBack()
        .pipe(takeUntil(this.ngUnsubscribe))  
        .subscribe(m => {            
            this.messageBusService.closeRouteDialog(new CloseRouteDialogMessage());
        }
    );
  } 

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getPublicProfile() : Observable<PublicProfile> {
    return this.publicProfileService.getPublicProfile(
      this.nickname,
      this.language,
      this.accountName);
  }

  sendPublicProfile(){
    let message = new PublicProfileMessage();
    message.publicProfile = this.publicProfile;

    this.messageBusService.sendPublicProfile(message);
  }

  getSpecialties() {
    if (!this.publicProfile.especialidades || this.publicProfile.especialidades.length == 0)
      return "";

    return this.publicProfile.especialidades.map(s => s.objetoDetalle).join(", ");
  }

}
